import { Spinner } from "@heroui/react"

function LoadingCard() {
  return (
   

    <div className="absolute  h-screen bg-white bg-opacity-50 z-10 h-full w-full flex items-center justify-center">
      <div className="flex items-center ">
        <Spinner size="lg" label="Loading..."  variant="wave" color="danger" labelColor="primary" />
      </div>
    </div>

  )
}
export default LoadingCard